import React from 'react';
import { withHydrate } from '@ecommerce/nest-ssr/common';

import StaticLayoutDesktop from 'layouts/static/static.desktop';
import ContactBase from './contact.base';

import './contact.desktop.scss';

const ContactDesktop: React.FC<{ title: string; }> = ({ title }) => (
    <StaticLayoutDesktop title={title}>
        <ContactBase />
    </StaticLayoutDesktop>
);

export default withHydrate(ContactDesktop, { root: '#root' }, 'views/pages/static/contact/contact.desktop');
